import { apiPost } from './http-client';

import type { StaffLoginResponse } from './auth-staff-login';

/** POST /api/v1/auth/me/select-trainer-branch */
export function postSelectTrainerBranch(
  branchId: number,
  accessToken: string
): Promise<StaffLoginResponse> {
  return apiPost<StaffLoginResponse>(
    '/api/v1/auth/me/select-trainer-branch',
    { branch_id: branchId },
    { accessToken }
  );
}
